import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import style from './EmailPreferences.module.scss';
import api from "helpers/api";
import Loader from "components/miscellaneous/Loader/Loader";
import { $t } from "helpers/translator";
import { setAlert } from "store/alerts-slice";
import { useDispatch } from "react-redux";

const EmailPreferencesWidget = () => {
    const dispatch = useDispatch();
    const [ lists, setLists ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const user = useSelector(state => state.auth.user)

    useEffect(() => {
        getLists()
    }, []);

    const getLists = async () => {
        try {
            const res = await api.get(`/email/lists`);
            if (res.success && res.data.data) {
                setLists(res.data.data);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const setListSubscription = async (listId, isSubscribed) => {
        setLists(lists.map(list => {
            if (list.id === listId) {
                list.subscribed = isSubscribed;
            }
            return list;
        }))
    }

    const submit = async () => {
        try {
            setLoading(true);
            const res = await api.post(`/email/preferences`, {
                lists: lists.map(list => {
                    return {
                        id: list.id,
                        subscribed: list.subscribed
                    }
                })
            });
            setLoading(false)
            dispatch(setAlert({ type: 'success' }));
            // console.log(res)
        } catch (error) {
            dispatch(setAlert({ type: 'error' }));
            console.error(error)
        }
    }

    return (
        <div>
                <div className={`alma-box`} style={{position: 'relative'}}>
                    <div className={'alma-box-header'}>
                        <span>
                            <h3 style={{margin:0}}>{ $t('global.emailPreferences.title') }</h3>
                            <p style={{margin:0, opacity: 0.5}}>{ $t('global.emailPreferences.subtitle') } { user.email }</p>
                        </span>
                    </div>
                    { loading && <div className={ style.loading }>
                        <Loader color="#ddd" />
                    </div> }
                    <div className={`alma-box-content`} style={{padding: '15px 10px'}}>
                        <div className={ style.preferences } style={{margin:0}}>
                            <div>
                                { $t('global.emailPreferences.intro') }
                            </div>

                            <div className={ style.lists } style={{
                                gap: 10
                            }}>
                                { lists.map(list => {
                                    const listName = list.list_name.split(' ').map((word, index) => {
                                        return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1);
                                    }).join('');

                                    return (
                                        <label className={ style.list } key={ list.id }>
                                            <div className={ style.checkbox }>
                                                <input type="checkbox" id={ `list-${list.id}` } name={ list.id } value={ list.id } checked={ list.subscribed } onChange={ (e) => {
                                                    const isChecked = e.target.checked;
                                                    setListSubscription(list.id, isChecked);
                                                } } />
                                            </div>
                                            <div className={ style.listDetails }>
                                                <div className={ style.listName } style={{
                                                    fontWeight: 400,
                                                    fontSize: 17
                                                }}>
                                                    { $t(`global.emailPreferences.lists.${listName}.title`) }
                                                </div>
                                                <div className={ style.listDescription }>
                                                    { $t(`global.emailPreferences.lists.${listName}.description`) }
                                                </div>
                                            </div>
                                        </label>
                                    )
                                }) }
                            </div>
                        </div>
                        <div className={ style.actions } style={{margin:0}}>
                            <button style={{
                                padding: '10px 20px',
                                borderRadius: '5px',
                            }} className={ style.unsubscribe } onClick={ () => {
                                setLists(lists.map(list => {
                                    list.subscribed = false;
                                    return list;
                                }))
                                submit();
                            } }>Unsubscribe from all</button>
                            <button className={ style.save } onClick={ () => {
                                submit();
                            } } style={{
                                padding: '10px 20px',
                                borderRadius: '5px',
                            }}>Save Changes</button>
                        </div>
                    </div>
                </div>
        </div>
    );
}

export default EmailPreferencesWidget;
